import { Link } from "react-router-dom";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, LOGO, waLink } from "@/lib/site";

const LINKS = [
  { label: "Startseite", href: "/#start" },
  { label: "Leistungen", href: "/#leistungen" },
  { label: "Transporte", href: "/#logistik" },
  { label: "Umzüge", href: "/#umzuege" },
  { label: "Über uns", href: "/#ueber-uns" },
  { label: "Kontakt", href: "/#kontakt" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative w-full bg-[#0a0a0a] grain border-t border-white/10">
    <div className="hazard-stripe h-[6px] w-full" />
    <div className="w-full px-5 sm:px-8 lg:px-12 py-12 sm:py-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <img src={LOGO} alt="Global Move Europa" className="h-14 sm:h-16 w-auto" />
        <div className="mt-4 eyebrow text-[#f95700]">{COMPANY.claim}</div>
        <p className="mt-4 text-sm text-neutral-400 leading-relaxed max-w-sm">
          Transporte und Umzüge aus Bremen – für Privatkunden und Unternehmen, deutschlandweit und
          europaweit.
        </p>
        <a
          href={waLink("Hallo Global Move Europa, ich habe eine Frage zu einem Transport.")}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-whatsapp-button"
          className="mt-6 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1eb857] text-white h-14 px-6 font-display text-base font-bold uppercase tracking-wide transition-colors"
        >
          <MessageCircle size={18} /> Frage per WhatsApp
        </a>
      </div>

      <div className="lg:col-span-3">
        <div className="eyebrow text-[#f95700] mb-5">Navigation</div>
        <ul className="space-y-3">
          {LINKS.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                data-testid={`footer-link-${l.label}`}
                className="font-display text-lg font-semibold uppercase text-neutral-300 hover:text-[#f95700] transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-3">
        <div className="eyebrow text-[#f95700] mb-5">Kontakt</div>
        <ul className="space-y-4 text-sm text-neutral-300">
          <li className="flex gap-3">
            <MapPin size={16} className="text-[#f95700] shrink-0 mt-0.5" />
            <span>
              {COMPANY.name}
              <br />
              {COMPANY.street}
              <br />
              {COMPANY.zip} {COMPANY.city}
            </span>
          </li>
          <li>
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex gap-3 hover:text-[#f95700] transition-colors" data-testid="footer-phone-link">
              <Phone size={16} className="text-[#f95700] shrink-0" />
              <span className="font-mono-t">{COMPANY.phoneDisplay}</span>
            </a>
          </li>
          <li>
            <a href={`mailto:${COMPANY.email}`} className="flex gap-3 hover:text-[#f95700] transition-colors" data-testid="footer-email-link">
              <Mail size={16} className="text-[#f95700] shrink-0" />
              <span className="font-mono-t break-all">{COMPANY.email}</span>
            </a>
          </li>
        </ul>
      </div>

      <div className="lg:col-span-2">
        <div className="eyebrow text-[#f95700] mb-5">Öffnungszeiten</div>
        <ul className="space-y-3 text-sm">
          {COMPANY.hours.map((h) => (
            <li key={h.d}>
              <div className="text-neutral-300 font-semibold">{h.d}</div>
              <div className="font-mono-t text-[12px] text-neutral-500">{h.t}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="w-full px-5 sm:px-8 lg:px-12 py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
      <span className="font-mono-t text-[10px] sm:text-[11px] text-neutral-500 uppercase tracking-widest text-center">
        © {new Date().getFullYear()} {COMPANY.name}
      </span>
      <div className="flex items-center gap-6">
        <Link to="/impressum" data-testid="footer-impressum-link" className="font-mono-t text-[11px] uppercase tracking-widest text-neutral-400 hover:text-[#f95700] transition-colors">
          Impressum
        </Link>
        <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="font-mono-t text-[11px] uppercase tracking-widest text-neutral-400 hover:text-[#f95700] transition-colors">
          Datenschutz
        </Link>
      </div>
    </div>
  </footer>
);
